import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig, countries, gamesCasino, profile } from 'config/config'; // Importing configuration settings

/**
 * Class representing the tableCryptosBlockchainView.
 * @extends JetView
 */
export default class tableCryptosBlockchainView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date format function
        return {
            rows: [
                {
                    id: 'preloader', // ID for preloader
                    cols: [
                        {
                            view: 'datatable', // DataTable component
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            id: 'datatable', // ID for the datatable
                            select: true, // Enable row selection
                            scrollY: true, // Enable vertical scrolling
                            columns: [
                                {
                                    id: 'rating', // Column ID
                                    header: 'Acciones', // Column header
                                    width: 100, // Column width
                                    height: 25, // Column height
                                    template: function (obj) {
                                        let content = '';

                                        if (devConfig.getPermAction('cryptoBlockchainView', 'Edit')) {
                                            content += "<span class='webix_icon wxi-search view' style='margin-right:8px; cursor:pointer;'></span>";
                                        }

                                        if (devConfig.getPermAction('cryptoBlockchainEdit', 'Edit')) {
                                            content += "<span class='webix_icon wxi-close edit'></span>";
                                        }

                                        // If there's at least one icon, we center the container.
                                        if (content) {
                                            return "<div style='display:flex; justify-content:center; align-items:center; height:100%'>" + content + "</div>";
                                        } else {
                                            return '';
                                        }
                                    }
                                },
                                {
                                    id: 'Id', // Column ID
                                    header: 'ID', // Column header
                                    width: 55, // Column width
                                    sort: 'int', // Sort type
                                },
                                {
                                    id: 'NameCryptoCurrency', // Column ID
                                    header: _('Criptomoneda'), // Localized column header
                                    width: 250, // Column width
                                    sort: 'int', // Sort type
                                },
                                {
                                    id: 'NameBlockchainNetwork', // Column ID
                                    header: _('Red Blockchain'), // Localized column header
                                    width: 250, // Column width
                                    sort: 'int', // Sort type
                                },
                                {
                                    id: 'RedBlockchainCode', // Column ID
                                    header: _('Código de Red'), // Localized column header
                                    width: 250, // Column width
                                    sort: 'int', // Sort type
                                },
                                {
                                    id: 'State', // Column ID
                                    header: _('Estado'), // Localized column header
                                    editor: 'combo', // Editor type
                                    options: [
                                        // Options for the combo editor
                                        { id: 'A', value: _('Activa') },
                                        { id: 'I', value: _('Inactiva') },
                                    ],
                                    width: 100, // Column width
                                    sort: 'int', // Sort type
                                },
                            ],
                            onClick: {
                                // Event handler for click events
                                edit: function (euv, id) {
                                    var item = this.getItem(id); // Get the clicked item
                                    $$("editform").setValues(item); // Set form values to the clicked item
                                    $$('editwinCryptoBlockchain').show(); // Show edit window on click
                                },
                                view: function (euv, id) {
                                    var item = this.getItem(id); // Get the clicked item
                                    $$("viewform").setValues(item); // Set form values to the clicked item
                                    $$('viewwinCryptoBlockchain').show(); // Show edit window on click
                                },
                            },
                            math: true, // Enable math operations
                            loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
                            pager: 'pagerA', // Pager ID
                            // API URL for fetching data
                            url:
                                devConfig.geturlApi() +
                                'CryptoNetworks/GetBlockchainCryptoCurrency',
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        const _ = this.app.getService('locale')._; // Localization service
        const id_partner = this.getParam('partner', true); // Get partner ID from parameters
        grid = $$('datatable'); // Reference to the datatable
        var url = grid.data.url; // Store the URL for data fetching
        var filter = ''; // Initialize filter variable
        var optionsCategorias = []; // Initialize options for categories
        var popup = webix.ui({
            // Create edit window UI
            view: 'window',
            id: 'editwinCryptoBlockchain', // ID for the edit window
            autowidth: screen.width < 500 ? 350 : 450, // Width based on screen size
            minHeight: screen.width < 500 ? 410 : 260, // Height based on screen size
            autoheight: true, // Auto height based on content
            head: {
                view: 'toolbar', // Toolbar for the window header
                cols: [
                    { view: 'label', label: _('Formulario de Edición Cripto + Red') }, // Label for the window
                    {
                        view: 'icon', // Close icon
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide(); // Hide window on click
                        },
                    },
                ],
            },
            position: 'center', // Center the window
            modal: true, // Modal window
            body: {
                view: 'scrollview', // Scrollable body
                scroll: 'y',
                body: {
                    view: 'form', // Form for editing
                    id: 'editform', // ID for the form
                    width: screen.width < 500 ? 350 : 450, // Width based on screen size
                    elements: [
                        {
                            view: 'text', // Text input for ID
                            label: 'Id',
                            name: 'Id',
                            readonly: true, // Read-only field
                            labelPosition: screen.width < 500 ? 'top' : 'left',
                            labelWidth: 130,   // space reserved for the label
                            inputWidth: 410,   // width of the input
                        },
                        {
                            view: 'text', // Text input for Product
                            label: _('Criptomoneda'),
                            name: 'NameCryptoCurrency',
                            readonly: true, // Read-only field
                            labelPosition: screen.width < 500 ? 'top' : 'left',
                            labelWidth: 130,   // space reserved for the label
                            inputWidth: 410,   // width of the input
                        },
                        {
                            view: 'text', // Text input for blockchain ID
                            label: _('Red Blockchain'),
                            name: 'NameBlockchainNetwork',
                            readonly: true, // Read-only field
                            labelPosition: screen.width < 500 ? 'top' : 'left',
                            labelWidth: 130,   // space reserved for the label
                            inputWidth: 410,   // width of the input
                        },
                        {
                            view: 'combo', // Combo box for activation status
                            label: _('Estado'),
                            name: 'State',
                            options: [
                                // Options for the combo box
                                { id: 'A', value: _('Activa') },
                                { id: 'I', value: _('Inactiva') },
                            ],
                            labelPosition: screen.width < 500 ? 'top' : 'left',
                            labelWidth: 130,   // space reserved for the label
                            inputWidth: 410,   // width of the input
                            required: true, // Required field
                        },
                        {
                            cols: [
                                // Button layout
                                {
                                    view: 'button', // Cancel button
                                    value: _('Cancelar'),
                                    click: function () {
                                        this.getTopParentView().hide(); // Hide window on click
                                        $$('editform').setValues(
                                            $$('editform').getCleanValues(), // Reset form values
                                        );
                                    },
                                },
                                {
                                    view: 'button', // Save button
                                    type: 'form',
                                    value: _('Guardar'),
                                    click: function ($e) {
                                        var values = $$('editform').getValues(); // Get form values
                                        var form = $$('editform');

                                        if (!form.validate()) {
                                            webix.message({ type: "error", text: _("Por favor, completa todos los campos obligatorios.") });
                                            return;
                                        }
                                        webix
                                            .ajax() // AJAX request to save changes
                                            .headers({
                                                'Content-type': 'application/json',
                                            })
                                            .post(
                                                devConfig.geturlApi() + 'CryptoNetworks/UpdateCryptoNetworks',
                                                '{"Id":' +
                                                values.Id +
                                                ',"State":"' +
                                                values.State +
                                                '","BlockchainIdNetwork":"' +
                                                values.BlockchainIdNetwork +
                                                '","CryptoCurrencyId":"' +
                                                values.CryptoCurrencyId +
                                                '"}',
                                                {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        webix.message(
                                                            'Error! ', // Error message on failure
                                                        );
                                                    },
                                                    success: function (text, data, XmlHttpRequest) {
                                                        webix.message(
                                                            'Criptomoneda a Red Blockchain Editada', // Success message
                                                        );
                                                        grid.clearAll(); // Clear grid data
                                                        grid.load(
                                                            url + '?start=0&count=' + grid.data.$pagesize + filter, // Reload grid data
                                                        );
                                                    },
                                                },
                                            );
                                        $$('editform').setValues(
                                            $$('editform').getCleanValues(), // Reset form values
                                        );
                                        this.getTopParentView().hide(); // Hide window after saving
                                    },
                                },
                            ],
                        },
                    ],
                },
            },
        });
        var viewPopup = webix.ui({
            // Create edit window UI
            view: 'window',
            id: 'viewwinCryptoBlockchain', // ID for the edit window
            autowidth: screen.width < 500 ? 350 : 450, // Width based on screen size
            minHeight: screen.width < 500 ? 410 : 260, // Height based on screen size
            autoheight: true, // Auto height based on content
            head: {
                view: 'toolbar', // Toolbar for the window header
                cols: [
                    { view: 'label', label: _('Visualización Cripto + Red') }, // Label for the window
                    {
                        view: 'icon', // Close icon
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide(); // Hide window on click
                        },
                    },
                ],
            },
            position: 'center', // Center the window
            modal: true, // Modal window
            body: {
                view: 'scrollview', // Scrollable body
                scroll: 'y',
                body: {
                    view: 'form', // Form for editing
                    id: 'viewform', // ID for the form
                    width: screen.width < 500 ? 350 : 450, // Width based on screen size
                    elements: [
                        {
                            view: 'text', // Text input for ID
                            label: 'Id',
                            name: 'Id',
                            readonly: true, // Read-only field
                            labelPosition: screen.width < 500 ? 'top' : 'left',
                            labelWidth: 130,   // space reserved for the label
                            inputWidth: 410,   // width of the input
                        },
                        {
                            view: 'text', // Text input for Product
                            label: _('Criptomoneda'),
                            name: 'NameCryptoCurrency',
                            readonly: true, // Read-only field
                            labelPosition: screen.width < 500 ? 'top' : 'left',
                            labelWidth: 130,   // space reserved for the label
                            inputWidth: 410,   // width of the input
                        },
                        {
                            view: 'text', // Text input for blockchain ID
                            label: _('Red Blockchain'),
                            name: 'NameBlockchainNetwork',
                            readonly: true, // Read-only field
                            labelPosition: screen.width < 500 ? 'top' : 'left',
                            labelWidth: 130,   // space reserved for the label
                            inputWidth: 410,   // width of the input
                        },
                        {
                            view: 'combo', // Combo box for activation status
                            label: _('Estado'),
                            name: 'State',
                            labelWidth: 130,   // space reserved for the label
                            inputWidth: 410,   // width of the input
                            readonly: true,
                            options: [
                                // Options for the combo box
                                { id: 'A', value: _('Activa') },
                                { id: 'I', value: _('Inactiva') },
                            ],
                            labelPosition: screen.width < 500 ? 'top' : 'left',
                        },
                        {
                            cols: [
                                // Button layout
                                {
                                    view: 'button', // Cancel button
                                    value: _('Cerrar'),
                                    click: function () {
                                        this.getTopParentView().hide(); // Hide window on click
                                    },
                                },
                            ],
                        },
                    ],
                },
            },
        });
        var vthis = this; // Preserve context for event handlers
        this.on(this.app, 'cryptosBlockchain:filter', (filterData) => {
            // Event handler for filtering
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize filter string
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        // Handle date range
                        var date = object[i][1].split(' - ');
                        console.log(date);
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to filter
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to filter
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object filters
                        var object2 = Object.entries(object[i][1]);
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    // Handle start date
                                    var d = new Date(object2[j][1]);
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add dateFrom to filter string
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Handle end date
                                        var d = new Date(object2[j][1]);
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add dateTo to filter string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear grid data
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Reload grid data with filters
            filter = string1; // Update filter variable
        });
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            // Event handler for sorting
            grid.refreshColumns(); // Refresh columns after sorting
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Reload grid data with sorting
            );
        });
        grid.attachEvent('onItemClick', function (id, e, node) {
            // Event handler for item clicks
            var item = this.getItem(id); // Get clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
        });
        this.on(this.app, 'player:select', (Id) => {
            // Event handler for player selection
            grid.load(
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id, // Load grid data for selected player
            );
        });
        $$('editform').bind($$('datatable')); // Bind edit form to datatable
        webix
            .ajax() // AJAX request to fetch initial data
            .headers({
                'Content-type': 'application/json',
            })
            .post(devConfig.geturlApi() + 'CryptoNetworks/GetBlockchainCryptoCurrency', '', {
                error: function (text, data, XmlHttpRequest) {
                    webix.message('Error! '); // Error message on failure
                },
                success: function (text, data, XmlHttpRequest) {
                    var resp = JSON.parse(text); // Parse response
                    for (var i = 0; i < resp.data.length; i++) {
                        resp.data[i].id = resp.data[i].Id; // Map ID
                        resp.data[i].value = resp.data[i].Description; // Map description
                    }
                    optionsCategorias = resp.data; // Store options for categories
                    var popupAdd = webix.ui({
                        // Create add product window UI
                        view: 'window',
                        id: 'AddCategoriesProduct', // ID for the add window
                        autowidth: screen.width < 500 ? 350 : 450, // Width based on screen size
                        minHeight: screen.width < 500 ? 360 : 210, // Height based on screen size
                        autoheight: true, // Auto height based on content
                        head: {
                            view: 'toolbar', // Toolbar for the window header
                            cols: [
                                {
                                    view: 'label',
                                    label: _('Formulario de Asociación Cripto + Red'), // Label for the window
                                },
                                {
                                    view: 'icon', // Close icon
                                    icon: 'wxi-close',
                                    click: function () {
                                        this.getTopParentView().hide(); // Hide window on click
                                    },
                                },
                            ],
                        },
                        position: 'center', // Center the window
                        modal: true, // Modal window
                        body: {
                            view: 'scrollview', // Scrollable body
                            scroll: 'y',
                            body: {
                                view: 'form', // Form for adding product
                                id: 'addformPB', // ID for the form
                                width: screen.width < 500 ? 350 : 450, // Width based on screen size
                                elements: [
                                    {
                                        view: 'combo', // Combo box for product selection
                                        name: 'CryptoCurrencyId',
                                        localId: 'cryptoCurrencyId:combo',
                                        label: _('Criptomonedas'), // Localized label
                                        labelPosition: screen.width < 500 ? 'top' : 'left',
                                        labelWidth: 130,   // space reserved for the label
                                        inputWidth: 410,   // width of the input
                                        required: true, // Required field
                                        placeholder: _(
                                            'Digita para seleccionar ', // Placeholder text
                                        ),
                                        options: {
                                            body: {
                                                dataFeed: function (text) {
                                                    // Data feed function for product options
                                                    var vthis = this;
                                                    if (text.length > 2) {
                                                        // Fetch data if input length is greater than 2
                                                        webix
                                                            .ajax()
                                                            .headers({
                                                                'Content-type': 'application/json',
                                                            })
                                                            .post(
                                                                devConfig.geturlApi() + 'es/Select/GetCryptoSummary',
                                                                '{"Filter":"' + text + '"}',
                                                                {
                                                                    error: function (text, data, XmlHttpRequest) {
                                                                        webix.message(
                                                                            'Error! ', // Error message on failure
                                                                        );
                                                                    },
                                                                    success: function (text, data, XmlHttpRequest) {
                                                                        var resp = JSON.parse(text); // Parse response
                                                                        if (!resp.HasError) {
                                                                            vthis.parse(
                                                                                resp.Data, // Parse data into combo
                                                                            );
                                                                        }
                                                                    },
                                                                },
                                                            );
                                                    }
                                                },
                                            },
                                        },
                                    },
                                    {
                                        view: 'combo', // Combo box for blockchain network selection
                                        name: 'BlockchainIdNetwork',
                                        localId: 'blockchainIdNetwork:combo',
                                        label: _('Red Blockchain'), // Localized label
                                        labelPosition: screen.width < 500 ? 'top' : 'left',
                                        labelWidth: 130,   // space reserved for the label
                                        inputWidth: 410,   // width of the input
                                        required: true, // Required field
                                        placeholder: _(
                                            'Digita para seleccionar ', // Placeholder text
                                        ),
                                        options: {
                                            body: {
                                                dataFeed: function (text) {
                                                    // Data feed function for blockchain network options
                                                    var vthis = this;
                                                    if (text.length > 2) {
                                                        // Fetch data if input length is greater than 2
                                                        webix
                                                            .ajax()
                                                            .headers({
                                                                'Content-type': 'application/json',
                                                            })
                                                            .post(
                                                                devConfig.geturlApi() + 'es/Select/BlockChainSelect',
                                                                '{"Filter":"' + text + '"}',
                                                                {
                                                                    error: function (text, data, XmlHttpRequest) {
                                                                        webix.message(
                                                                            'Error! ', // Error message on failure
                                                                        );
                                                                    },
                                                                    success: function (text, data, XmlHttpRequest) {
                                                                        var resp = JSON.parse(text); // Parse response
                                                                        if (!resp.HasError) {
                                                                            vthis.parse(
                                                                                resp.Data, // Parse data into combo
                                                                            );
                                                                        }
                                                                    },
                                                                },
                                                            );
                                                    }
                                                },
                                            },
                                        },
                                    },
                                    {
                                        view: 'combo', // Combo box for activation status
                                        label: _('Estado'),
                                        name: 'State',
                                        labelWidth: 130,   // space reserved for the label
                                        inputWidth: 410,   // width of the input
                                        required: true, // Required field
                                        options: [
                                            {
                                                id: 'A',
                                                value: _('Activa'), // Localized value
                                            },
                                            {
                                                id: 'I',
                                                value: _('Inactiva'), // Localized value
                                            },
                                        ],
                                        labelPosition: screen.width < 500 ? 'top' : 'left',
                                        placeholder: _(
                                            'Click para seleccionar ', // Placeholder text
                                        ),
                                    },
                                    {
                                        cols: [
                                            // Button layout
                                            {
                                                view: 'button', // Cancel button
                                                value: _('Cancelar'),
                                                click: function () {
                                                    this.getTopParentView().hide(); // Hide window on click
                                                    $$('addformPB').setValues(
                                                        $$('addformPB').getCleanValues(), // Reset form values
                                                    );
                                                },
                                            },
                                            {
                                                view: 'button', // Save button
                                                type: 'form',
                                                value: _('Guardar'),
                                                click: function ($e) {
                                                    var values = $$('addformPB').getValues(); // Get form values
                                                    var form = $$('addformPB');

                                                    if (!form.validate()) {
                                                        webix.message({ type: "error", text: _("Por favor, completa todos los campos obligatorios.") });
                                                        return;
                                                    }
                                                    webix
                                                        .ajax() // AJAX request to save new cryptoCurrency and blockchain association
                                                        .headers({
                                                            'Content-type': 'application/json',
                                                        })
                                                        .post(
                                                            devConfig.geturlApi() +
                                                            'CryptoNetworks/SaveBlockchainCryptoCurrency',
                                                            '{"BlockchainIdNetwork":"' +
                                                            values.BlockchainIdNetwork +
                                                            '", "CryptoCurrencyId":"' +
                                                            values.CryptoCurrencyId +
                                                            '", "State":"' +
                                                            values.State +
                                                            '"}',
                                                            {
                                                                success: function (text, data, XmlHttpRequest) {
                                                                    var resp = JSON.parse(text);
                                                                    if(resp.HasError) {
                                                                        return;
                                                                    }else {
                                                                        webix.message(
                                                                            'Criptomoneda Red Blockchain Agregada', // Success message
                                                                        );
                                                                        grid.clearAll(); // Clear grid data
                                                                        grid.load(
                                                                            url +
                                                                            '?start=0&count=' +
                                                                            grid.data.$pagesize +
                                                                            filter, // Reload grid data
                                                                        );
                                                                    }
                                                                },
                                                            },
                                                        );
                                                    $$('addformPB').setValues(
                                                        $$('addformPB').getCleanValues(), // Reset form values
                                                    );
                                                    this.getTopParentView().hide(); // Hide window after saving
                                                },
                                            },
                                        ],
                                    },
                                ],
                            },
                        },
                    });
                    vthis.on(vthis.app, 'addCryptoBlockchain:button', (filter) => {
                        popupAdd.show(); // Show add cryptoCurrency window
                    });
                },
            });
    }
}

// FILE DOCUMENTED
